import styled from '@emotion/styled';
import { gutterSizes, colorVariables } from '@gumtree/ui-library/src/base/theme';

export const StyledSeoFaqContent = styled.div`
    a {
        margin-left: ${gutterSizes.small};
        color: ${colorVariables.mainTertiary};

        &:hover {
            text-decoration: underline;
        }
    }
`;
